import {
  MODELS_HELPER_TEXT,
  MODELS_PREFIX,
  withAllowedModelsHint,
} from "../models";
import { openaiUsage } from "../openai/usage";
import { OPENAI_COMPATIBLE_USAGE_HINT } from "../openai/usageHint";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const DEFAULT_PERPLEXITY_BASE_URL = "https://api.perplexity.ai";

export const perplexity = defineConnector({
  identifier: "perplexity",
  name: "Perplexity",
  tagLine: "AI-powered search and answer engine",
  logo,
  protocol: "http",
  tags: ["ai", "data"],
  defaultUrlPattern: () => "https://api\\.perplexity\\.ai/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [Perplexity API Settings](https://www.perplexity.ai/settings/api) and generate an API key.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
    {
      title: "Choose available models (optional)",
      items: [
        {
          kind: "list",
          label: "Available models",
          prefix: MODELS_PREFIX,
          columns: [{ field: "name", placeholder: "sonar-pro" }],
          addLabel: "Add model",
          helperText: `${MODELS_HELPER_TEXT} Perplexity publishes no models endpoint, so enter model names by hand.`,
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => `${DEFAULT_PERPLEXITY_BASE_URL}/chat/completions`,
  },
  usageHint: (configuration) =>
    withAllowedModelsHint(OPENAI_COMPATIBLE_USAGE_HINT, configuration),
  usage: openaiUsage(),
});
